'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import Script from 'next/script'
import { isSiteSearchQuery, resetSiteSearchDedup } from '@/lib/site-search-tracking'

const MATOMO_URL = 'https://matomo.2umdrehungen.com/'

export function MatomoAnalytics({ siteId = '3' }: { siteId?: string }) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const search = searchParams.toString()

  useEffect(() => {
    const currentUrl = search ? `${pathname}?${search}` : pathname
    window._paq = window._paq || []

    if (!window.__partyamtMatomoConfigured) {
      // DSGVO: cookieless + DoNotTrack respektieren → kein Consent nötig.
      // (Finale IP-Anonymisierung zusätzlich serverseitig in der Matomo-Admin aktivieren.)
      window._paq.push(['disableCookies'])
      window._paq.push(['setDoNotTrack', true])
      window._paq.push(['enableLinkTracking'])
      window._paq.push(['setTrackerUrl', `${MATOMO_URL}matomo.php`])
      window._paq.push(['setSiteId', siteId])
      window.__partyamtMatomoConfigured = true
    }

    window._paq.push(['setCustomUrl', currentUrl])
    window._paq.push(['setDocumentTitle', document.title])

    // Suchzustände meldet SearchTracker via trackSiteSearch — kein zweiter Hit (Matomo-Empfehlung).
    if (isSiteSearchQuery(new URLSearchParams(search).get('q'))) return

    resetSiteSearchDedup()
    window._paq.push(['trackPageView'])
  }, [pathname, search, siteId])

  return (
    <>
      <Script id="matomo-init" strategy="afterInteractive">
        {`
          var _paq = window._paq = window._paq || [];
        `}
      </Script>
      <Script id="matomo-script" src={`${MATOMO_URL}matomo.js`} strategy="afterInteractive" />
    </>
  )
}
